import some from "lodash/some";
import { useFiltersBufferState } from "PFApp/components/filters_v2";
import { Button } from "PFComponents/button";
import { useSavedFiltersV2 } from "PFCore/hooks/queries/filters/use_saved_filters_v2";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { useFiltersV2Select } from "../../stores";
import { SavedFiltersProps } from "../filters_v2_panel";
import { isSavedFiltersCollectionSelected } from "./helpers";
import { useIsProcessingSavedFiltersCollections } from "./hooks/use_is_processing_saved_filters_collections";
import { SavedFiltersCollectionCreateModal } from "./parts/modals";

export const SaveFiltersButton = ({ omit }: SavedFiltersProps) => {
  const { t } = useTranslation("filters", { keyPrefix: "save" });
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);

  const { buffer: filtersMeta, collection } = useFiltersV2Select("buffer", "collection");

  const { areFiltersDefaultOrEmpty } = useFiltersBufferState();
  const { data: savedCollections } = useSavedFiltersV2(collection!);

  const isAnyCollectionSelected = useMemo(
    () =>
      savedCollections &&
      some(savedCollections, ({ collection }) =>
        isSavedFiltersCollectionSelected(filtersMeta, collection, omit)
      ),
    [filtersMeta, savedCollections, omit]
  );

  const isProcessing = useIsProcessingSavedFiltersCollections();

  const isSaveAsViewDisabled = isAnyCollectionSelected || areFiltersDefaultOrEmpty || isProcessing;

  return (
    <>
      <Button kind="secondary" onClick={() => setIsSaveModalOpen(true)} disabled={isSaveAsViewDisabled}>
        {t("saveAsView")}
      </Button>
      {isSaveModalOpen && (
        <SavedFiltersCollectionCreateModal onClose={() => setIsSaveModalOpen(false)} omit={omit} />
      )}
    </>
  );
};
